import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

function ModalReport({ polygons = [], data, onItemsChecked, onPolygonsChecked }) {

    const [checked, setChecked] = useState([]);
    const [checkedPolygons, setCheckedPolygons] = useState([]);

    const otherData = [
        "ownership",
        "licensingWaiver",
        "environmentalLicense",
        "noticeInfraction",
        "tacAgency",
        "tacMp",
        "otherAdministrativeProcesses",
        "judicialProcess",
        "car",
        "dueDiligence"
    ]

    const items = polygons.length > 0 ? otherData : Object.keys(data).filter((item) => typeof data[item] == 'object');

    const trasformLabels = (item) => {
        let label = '';
        switch (item) {
            case 'ownership':
                label = 'Titularidade';
                break;
            case 'licensingWaiver':
                label = 'Dispensa de Licenciamento';
                break;
            case 'environmentalLicense':
                label = 'Licença Ambiental';
                break;
            case 'noticeInfraction':
                label = 'Auto de Infração';
                break;
            case 'tacAgency':
                label = 'TAC Órgão Ambiental';
                break;
            case 'tacMp':
                label = 'TAC Ministério Público';
                break;
            case 'otherAdministrativeProcesses':
                label = 'Outros Processos Administrativos';
                break;
            case 'judicialProcess':
                label = 'Processo Judicial';
                break;
            case 'car':
                label = 'CAR';
                break;
            case 'dueDiligence':
                label = 'Due Diligence';
                break;

            default:
                break;

        }
        return label;
    }

    const handleCheck = (event) => {
        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
        onItemsChecked(updatedList);
    };

    const handleCheckPolygons = (event) => {
        var updatedList = [...checkedPolygons];
        if (event.target.checked) {
            updatedList = [...checkedPolygons, event.target.value];
        } else {
            updatedList.splice(checkedPolygons.indexOf(event.target.value), 1);
        }
        setCheckedPolygons(updatedList);
        onPolygonsChecked(updatedList);
    };

    const handleCheckAll = (event) => {
        if (event.target.checked) {
            setChecked(otherData);
            onItemsChecked(otherData);
        } else {
            setChecked([]);
        }

    }

    const checkedItems = checked.length
        ? checked.reduce((total, item) => {
            return total + ", " + item;
        })
        : "";

    return (
        <>
            <Row>
                {polygons.length <= 0 ? '' :
                    <Col md={5}>
                        <b>Selecione a(s) propriedade(s):</b>
                        <section className='scrollbar' style={{ height: '250px' }}>
                            <Form>
                                {polygons.map((item, index) => (
                                    <div key={item.id} className={(index % 2) == 1 ? "mb-3 list-even-odd even-content" : "mb-3 list-even-odd odd-content"}>
                                        <Form.Check // prettier-ignore
                                            type='checkbox'
                                            id={`id${item.id}`}
                                            label={item.title}
                                            value={item.id}
                                            onChange={handleCheckPolygons}
                                        />

                                    </div>
                                ))}
                            </Form>
                        </section>
                    </Col>
                }
                <Col md={polygons.length > 0 ? 7 : 12}>
                    {polygons.length > 0 ? <b>Escolha abaixo os itens que você deseja incluir no relatório da(s) propriedade(s).</b> : <b>Escolha abaixo os itens que você deseja incluir no relatório da propriedade.</b>}
                    <div className='list-even-odd odd-content mb-3' style={{padding: '3px 8px'}}>
                        <Form.Check // prettier-ignore
                            type='checkbox'
                            label='Selecionar todos'
                            onChange={handleCheckAll}
                        />
                    </div>
                    <Form style={{ columnCount: 2 }}>
                        {items.map((item) => (
                            <div key={item} className="mb-3">
                                <Form.Check // prettier-ignore
                                    type='checkbox'
                                    id={`id${item}`}
                                    label={trasformLabels(item)}
                                    value={item}
                                    checked={checked.includes(item)}
                                    onChange={handleCheck}
                                />

                            </div>
                        ))}
                    </Form>
                </Col>
            </Row>

            {/* <div>{`Items checked are: ${checkedItems}`}</div> */}
        </>
    );
}

export default ModalReport;